import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { selectIsMobile } from 'selectors/ui';
import { closeModal } from 'components/Modal';

import ImageCarousel from './ImageCarousel';

const mapStateToProps = state => {
  return {
    isMobile: selectIsMobile(state),
  };
};

const mapDispatchToProps = {
  closeModal,
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(ImageCarousel);
